export const getPhoneDigits = (value: string): string => value.replace(/\D/g, '');
